// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"916710aa","534":"4a7aaca1"}[chunkId] + ".chunk.css";
};